import React from "react";
import live1 from "public@assets/images/line-1.png";
import live2 from "public@assets/images/line-2.png";
import live3 from "public@assets/images/line-3.png";
import live4 from "public@assets/images/line-4.png";
import live5 from "public@assets/images/line-5.png";
import live6 from "public@assets/images/line-6.png";
import live7 from "public@assets/images/line-7.png";
import live8 from "public@assets/images/line-8.png";
import live9 from "public@assets/images/line-9.png";
import livePlayer from "public@assets/images/live-player.png";
import "./style/style.scss";
interface IProps {
  interactiveType?: string;
}

export default class AnimationComponent extends React.Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    const { interactiveType } = this.props;
    const isMobile = interactiveType === "mobile";
    return (
      <div className="play__container">
        {!isMobile && <img className="animation-logo" src={livePlayer} alt="" />}
        <img className="animation animation1" src={live9} alt="" />
        <img className="animation animation2" src={live1} alt="" />
        <img className="animation animation3" src={live2} alt="" />
        <img className="animation animation4" src={live3} alt="" />
        <img className="animation animation5" src={live4} alt="" />
        <img className="animation animation6" src={live5} alt="" />
        <img className="animation animation7" src={live6} alt="" />
        <img className="animation animation8" src={live7} alt="" />
        <img className="animation animation9" src={live8} alt="" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pc/component/animation/index.tsx